import { jsxs as x, jsx as r } from "react/jsx-runtime";
import { Fragment as u } from "react";
import { IconStar as o } from "../Icons/index.js";
import { ratingSizes as N } from "./Rating.types.js";
import { mergeClasses as g } from "../../utils/merge-classes.js";
const y = N.reduce(
  (e, t) => (e[t] = {
    filled: /* @__PURE__ */ r(
      o,
      {
        className: "text-color-scheme-functional-special-400",
        size: t,
        variant: "solid"
      }
    ),
    half: /* @__PURE__ */ r(
      o,
      {
        className: "text-color-scheme-functional-special-400",
        size: t,
        variant: "half"
      }
    ),
    empty: /* @__PURE__ */ r(
      o,
      {
        className: "text-color-scheme-neutral-200",
        size: t,
        variant: "outlined"
      }
    )
  }, e),
  {}
), s = 5, I = (e, t = {}) => ({
  ...y[e],
  ...t[e]
}), _ = ({
  className: e,
  hideEmptyIcons: t,
  hiddenLabel: c,
  icons: m = {},
  size: i = "md",
  value: a,
  ...f
}) => {
  a = Math.min(s, Math.max(0, a));
  const { filled: p, half: h, empty: d } = I(i, m);
  return /* @__PURE__ */ x(
    "span",
    {
      className: g(
        "inline-flex [&:not(:first-of-type)]:*:-ms-025",
        e
      ),
      ...f,
      children: [
        [...Array(s)].map((A, n) => {
          let l = t ? null : d;
          return a >= n + 1 ? l = p : a >= n + 0.5 && (l = h), /* @__PURE__ */ r(u, { children: l }, n);
        }),
        /* @__PURE__ */ r("span", { className: "sr-only", children: c })
      ]
    }
  );
};
export {
  _ as Rating
};
